import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { api_urls } from "../../../utils/api-urls/index.js";
import * as EcommerceActions from '../../../redux/actions/ecommerceAction.js';
import MainDatatable from "../../../components/common/MainDatatable.jsx";
import logo_icon from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { DeleteSvg, EditSvg, SwitchOffSvg, SwitchOnSvg } from "../../../assets/svg/index.js";

const DisplayProduct = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ecommerceProductData, ecommerceCategoryData, ecommerceSubCategoryByCategoryIdData, ecommerceAttributeData } = useSelector(state => state.ecommerceReducer);

  //* Sub Category DataTable Columns
  const ecommerceProductColumns = [
    { name: 'S.No.', selector: row => ecommerceProductData.length - ecommerceProductData.indexOf(row), style: { backGroundColor: "#000", paddingLeft: "20px" } },
    { name: 'Title', selector: row => row?.title },
    { name: 'description', selector: row => row?.description },
    { name: 'Mrp', selector: row => row?.mrp },
    { name: 'Current Price', selector: row => row?.current_price },
    { name: 'Purchased Price', selector: row => row?.purchased_price },
    { name: 'Image', cell: row => <img src={row?.image ? api_urls + row?.image : logo_icon} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
    { name: 'Status', selector: row => <div onClick={() => dispatch(EcommerceActions?.changeEcommerceProductStatus({ productId: row?._id }))} style={{ cursor: "pointer" }}>{row?.status == 'Active' ? <SwitchOnSvg /> : <SwitchOffSvg />}</div> },
    {
      name: 'Action',
      cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
        <div onClick={() => navigate('/e-commerce/add-product', { state: { stateData: row } })} style={{ cursor: "pointer" }}><EditSvg /></div>
        <div onClick={() => dispatch(EcommerceActions.deleteEcommerceProduct({ productId: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
      </div >,
      width: "180px"
    },
  ];

  useEffect(() => {

    //! Dispatching API for Getting Product
    dispatch(EcommerceActions.getEcommerceProduct())
  }, []);

  return (
    <>
      <MainDatatable data={ecommerceProductData} columns={ecommerceProductColumns} title={'Product'} url={'/e-commerce/add-product'} />

    </ >
  );
}

export default DisplayProduct;